import { FC } from 'react';
// components
import AddProductSizeComponent from 'components/main/ProductSize/Edit';

const AddProductSize: FC = () => <AddProductSizeComponent />;

export default AddProductSize;
